/**
 *
 * Shell
 *
 */
import React, { EffectCallback, Suspense, useEffect, useState } from 'react';
import './Shell.scss';
import { ShellHeader } from './ShellHeader';
import { SideNav } from './ShellSideNav';
import { sideNavMenu } from '../../sideBarRoutes';
import { ThemeContext } from 'context/themeContext';
import { ThemeContextType } from 'types/theme';
const SEARCH_MAX_WIDTH = 1250;
const MEDIUM_MAX_WIDTH = 950;
const SMALL_MAX_WIDTH = 700;
const X_SMALL_MAX_WIDTH = 575;

export const IS_STAGE_ENVIRONMENT = (
  process.env.REACT_APP_API_V2_URL || ''
).includes('stage');

export function Shell({ children, ...otherProps }) {
  const [maxFullSearchSize, setMaxFullSearchSize] = useState(true);
  const [sideNavOpen, setSideNavOpen] = useState(true);
  const [size, setSize] = useState('L');
  const { sideNavEnabled } = React.useContext(ThemeContext) as ThemeContextType;

  useEffect((): ReturnType<EffectCallback> => {
    window.addEventListener('resize', onResize);
    onResize();
    return (): void => {
      window.removeEventListener('resize', onResize);
    };
  });
  const toggleSideNav = () => {
    setSideNavOpen(!sideNavOpen);
  };
  const onResize = () => {
    const width = window.innerWidth;
    let newSize;
    let maxSearchSize = false;

    if (width > MEDIUM_MAX_WIDTH) {
      newSize = 'L';
    } else if (width <= X_SMALL_MAX_WIDTH) {
      newSize = 'XS';
    } else if (width <= SMALL_MAX_WIDTH) {
      newSize = 'S';
    } else {
      newSize = 'M';
    }

    if (width <= SEARCH_MAX_WIDTH) {
      maxSearchSize = true;
    }

    if (newSize !== size) {
      setSize(newSize);
    }

    if (maxSearchSize !== maxFullSearchSize) {
      setMaxFullSearchSize(maxSearchSize);
    }
  };
  const sideNavConfig = {
    settings: {},
    menu: sideNavMenu
  };
  return (
    <>
      <ShellHeader
        {...otherProps}
        toggleSideNav={toggleSideNav}
        data-testid="shell-header"
      />
      <div
        className="spectrum-ShellContainer-content"
        data-testid="shell-container-content"
      >
        {sideNavConfig && (
          <Suspense fallback={null}>
            <SideNav
              isOpen={sideNavEnabled && sideNavOpen}
              selectedSideNavItemId="hom1"
              sideNavConfig={sideNavConfig}
              {...otherProps}
              data-testid="shell-side-nav"
            />
          </Suspense>
        )}
        {children}
      </div>
    </>
  );
}
